import './paymentSearch.scss'
import { priceTagFormatter } from '../../../../../constants/utils';
import { TPaymentSearch } from '../../interface';

const Index = ({ data, searchCallBack}: TPaymentSearch) => {

    return (

        <ul className="custom-search card p-0">
            {data.length > 0 ? data?.map((item) => {
                return (
                    <li className="list-unstyled list-hover cursor-pointer px-3 d-flex">
                        <div className='fs-16 cursor-pointer col-9' onClick={() => searchCallBack(item)}>
                            <div className='d-flex'>
                                <h3 className="fs-12 fw-600 secondary-color">Customer Name : </h3>
                                <h3 className="fs-12 fw-600 secondary-color" style={{ marginLeft: "10px" }}>{item?.gl_account_name}</h3>
                            </div>
                            <div className='d-flex' >
                                <h3 className="fs-12 fw-600 secondary-color" >GL Number : </h3>
                                <h3 className=" fs-12 fw-600 secondary-color" style={{ marginLeft: "10px" }}>{item?.gl_number}</h3>
                            </div>
                            <div className='d-flex' >
                                <h3 className="fs-12 fw-600 secondary-color" >Balance : </h3>
                                <h3 className=" fs-12 fw-600 secondary-color" style={{ marginLeft: "10px" }}>{priceTagFormatter(-item?.balance)}</h3>
                            </div>
                        </div>
                    </li>
                )
            }) :
                <li className="list-unstyled list-hover cursor-pointer p-1 px-3 d-flex">
                    <div className='fs-16 cursor-pointer col-11'>
                        <div className="fw-500 text-capitalize py-3">
                            No product found
                        </div>
                    </div>
                </li>
            }
        </ul>
    )
}
export default Index